import axios from 'axios'
import Vuex from 'vuex'
import Vue from 'vue'
import store from '../store'

Vue.use(Vuex, axios)

const createHeader = function () {
  const credential = store.getters['config/getCredential']
  var userLang = navigator.language || navigator.userLanguage
  var headerObj = {};
  if (credential) {
    if (!credential.locale) {
      credential.locale = userLang.replace('-', '_')
    }
    if (credential && credential.apiEncryptedUser) {
      headerObj = {
        'X-ApiEncryptedUser': credential.apiEncryptedUser
      }
    } else if (credential && credential.apiKey) {
      headerObj = {
        'X-ApiKey': credential.apiKey
      }
    }
  }
  return headerObj;
}

const getSearchUrl = function () {
  const buildYourJewelMode = store.getters['buildYourJewel/getBuildYourJewelMode']
  return buildYourJewelMode ? `${process.env.VUE_APP_BASE_URL}/build-your-jewel/stone/search` : `${process.env.VUE_APP_BASE_URL}/stones/search`;
}

const getCountUrl = function () {
  const buildYourJewelMode = store.getters['buildYourJewel/getBuildYourJewelMode']
  return buildYourJewelMode ? `${process.env.VUE_APP_BASE_URL}/build-your-jewel/stone/count` : `${process.env.VUE_APP_BASE_URL}/stones/count`;
}

const addBuildYourJewelParams = function (request) {
  const buildYourJewelModeSetting = store.getters['buildYourJewel/getSelectedSetting'];
  if (buildYourJewelModeSetting) {
    request.settingSku = buildYourJewelModeSetting.sku;
  }

  const buildYourJewelSelectedStones = store.getters['buildYourJewel/getSelectedStones'];
  const buildYourJewelStonesNumber = store.getters['buildYourJewel/getStonesNumber'];
  if (buildYourJewelSelectedStones && buildYourJewelSelectedStones.length > 0 && buildYourJewelStonesNumber > 1) {
    request.diamondIds = buildYourJewelSelectedStones?.map(stone => stone.id);
    request.query.filter_ids = request.query.filter_ids ? [...new Set(request.query.filter_ids.concat(buildYourJewelSelectedStones.map(s => s.diamond.id)))] : buildYourJewelSelectedStones.map(s => s.diamond.id);
  }
  request.jewelStonesNumber = buildYourJewelStonesNumber;

  const credential = store.getters['config/getCredential']
  request.backoffice = credential?.isBO;
}


export default {

  search(request) {
    addBuildYourJewelParams(request);
    const credential = store.getters['config/getCredential']
    const params = new URLSearchParams();
    params.append('locale', credential?.locale);


    return axios
      .post(
        getSearchUrl(), request,
        {
          headers: createHeader(),
          params: params
        }
      )
  },

  count(request) {
    addBuildYourJewelParams(request);
    const credential = store.getters['config/getCredential']
    const params = new URLSearchParams();
    params.append('locale', credential?.locale);
    return axios
      .post(
        getCountUrl(), request,
        {
          headers: createHeader(),
          params: params
        }
      )
  }
}
